import './index.css'
import cn from 'clsx'
import * as React from 'react'
type Props = {
  image?: string | null | undefined
  type?: 'blur' | 'gradient'
}

/**
 * Background image component with blur and gradient overlay effects
 * Used for creating visual backgrounds in public pages and banners
 * @param image - URL of the background image to display
 * @param type - Visual effect to apply ('blur' or 'gradient')
 */
const BackgroundImage = ({ image, type }: Props): React.ReactElement<'div'> => {
  const bannerStyles = image
    ? {
        backgroundImage: `url("${image}")`,
      }
    : {}
  return (
    <div
      className={cn('public-banner', {
        'public-banner--blur': image && type === 'blur',
        'public-banner--gradient': image && type === 'gradient',
      })}
    >
      <div className="public-banner-image" style={bannerStyles} />
    </div>
  )
}

export default BackgroundImage
